export function isIE(): boolean {
    return !!document.documentMode
        || window.navigator.userAgent.includes("MSIE");
}

export function isEdge(): boolean {
    return window.navigator.userAgent.includes("Edge");
}
